import { useMemo } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByStayDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData | undefined;
};

export const useReservationListByStayDateQueryData = ({ serverData }: Props) => {
	return useMemo((): Result => {
		return {
			queryData: serverData
				? {
						hotelName: serverData.reservationListByStayDate.hotelName,
						hotelPrefecture: serverData.reservationListByStayDate.hotelPrefecture,
						reservationList: serverData.reservationListByStayDate.reservations,
					}
				: undefined,
		};
	}, [serverData]);
};
